import { useSyncExternalStore } from 'react';
import type { SidebarPins } from './sidebar-menu.util';

/**
 * The tabbed sidebar's pin actions, for surfaces outside it (the Chats rail
 * on /clu). The sidebar owns the one layout and its one-save-at-a-time
 * queue; it publishes the same actions its own menus use, so a pin made
 * elsewhere goes through that queue and shows in the sidebar at once. Null
 * while the tabbed sidebar is not mounted.
 */
let current: SidebarPins | null = null;
const listeners = new Set<() => void>();

export function publishSidebarPins(pins: SidebarPins | null): void {
  if (current === pins) return;
  current = pins;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const read = () => current;
const readOnServer = () => null;

/** The sidebar's pin actions, or null without the tabbed sidebar. */
export function useSharedSidebarPins(): SidebarPins | null {
  return useSyncExternalStore(subscribe, read, readOnServer);
}
